import { Mail } from "lucide-react";
import { FaInstagram, FaTiktok, FaWhatsapp } from "react-icons/fa";

export function Footer() {
  const socialLinks = [
    {
      name: "Instagram",
      url: "https://www.instagram.com/pedidoz.online/",
      icon: (
        <FaInstagram className="w-6 h-6 hover:text-[#FF9A3C] transition-colors duration-300" />
      ),
    },
    {
      name: "TikTok",
      url: "https://www.tiktok.com/@pedidoz.online",
      icon: (
        <FaTiktok className="w-6 h-6 hover:text-[#FF9A3C] transition-colors duration-300" />
      ),
    },
    {
      name: "WhatsApp",
      url: "https://wa.me/5547988355092",
      icon: (
        <FaWhatsapp className="w-6 h-6 hover:text-[#FF9A3C] transition-colors duration-300" />
      ),
    },
    {
      name: "Email",
      url: "mailto:contato@pedidoz.online",
      icon: (
        <Mail className="w-6 h-6 hover:text-[#FF9A3C] transition-colors duration-300" />
      ),
    },
  ];

  return (
    <footer className="bg-gradient-to-r from-[#050505] via-[#0A0501] to-[#050505] text-white py-6">
      <div className="container mx-auto px-4 flex flex-col items-center justify-between sm:flex-row">
        <div className="text-sm mb-4 sm:mb-0">
          <p className="text-white/80">
            © 2025 PedidoZ. Todos os direitos reservados.
          </p>
          <p className="text-white/60 mt-1">
            Contato: (47) 98835-5092 | contato@pedidoz.online
          </p>
        </div>
        <div className="flex space-x-4">
          {socialLinks.map((link) => (
            <a
              key={link.name}
              href={link.url}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={link.name}
              className="transition-transform transform hover:scale-110"
            >
              {link.icon}
            </a>
          ))}
        </div>
      </div>
    </footer>
  );
}
